import GFooterNewsletterSignup from './g-footer-newsletter-signup.vue';

export default GFooterNewsletterSignup;
